module.exports = "<div class=\"modal-header\">\n  <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"cancel()\" data-ng-hide=\"hideClose\">&times;</button>\n  <p class=\"modal-title\">{{config.title}}</p>\n</div>\n<div class=\"modal-body\">\n  <login config=\"config\" input=\"input\" ng-hide=\"loginComplete\"></login>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/services/modal/login/login.html
// module id = 883
// module chunks = 1